import { FamiliaIndicadores } from '../../core/_models'
import { IndicadoresExportacao } from './IndicadoresExportacao'
import { IndicadoresSearchComponent } from './IndicadoresSearchComponent'

type Props = {
  /** Família exibida — a exportação baixa sempre o arquivo da aba visível. */
  familia: FamiliaIndicadores
}

export const IndicadoresHeader = ({ familia }: Props) => {
  return (
    <div>
      <IndicadoresSearchComponent />
      <IndicadoresExportacao familia={familia} />
    </div>
  )
}
